import React, {useState} from 'react';
import AuthNav from '../whitaijiFrontendLibrary/auth/components/AuthNav'
import { AuthContext } from '../context/AuthContext'
import { Link } from 'react-router-dom'
import { useDocumentsContext } from '../hooks/useDocumentsContext'
import localforage from 'localforage'
import {HiMenu} from 'react-icons/hi';
import Sidebar from '../components/Sidebar'
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv'
import { useStateContext } from '../context/StateContext';
import useMediaQuery from '../hooks/useMediaQuery';
import ProfileMenu from './ProfileMenu';
import { isGodMode } from '../utils/permissions';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';


const Navbar = () => {
  const { user } = useAuthContext(AuthContext)
 //process.env.NODE_ENV === "development" && console.log("user", user)
  const { dispatch: dispatchdocuments } = useDocumentsContext()
     const {showSidebar, setShowSidebar} = useStateContext();
  const screenSizeNotMobile = useMediaQuery("(min-width: 742px)")
  localforage.config({
    name: 'reMind',
    isPersistent: true
  })

  const toggle = () => {
    setShowSidebar(true)
    //process.env.NODE_ENV === "development" && console.log("user", sUser)
    //process.env.NODE_ENV === "development" && console.log(showSidebar)
    //setModalOpen(true)
}

  const resetContextFn = () => {
    console.log("resetContextFn") 
    dispatchdocuments({ type: 'SET_DOCUMENTS', payload: null }) 
    
  }

  return (
    <header>
      <div className="navbar-container">
        <div className='navbar-left'>
          <VisDiv>
            { showSidebar ? 
                <Sidebar/> 
                :
                <HiMenu
                fontSize={40}
                className="mobile-menu-icon"
                onClick={() => toggle()}
                />
            }
          </VisDiv>
        </div>
        <div className="logo">
          <Link to="/">
            <img src="/reMindLogo.png" alt="reMind Logo" style={{ maxWidth: '100%', maxHeight: '120px' }} />
          </Link>
        </div>
        <div className='navbar-right'>
          {screenSizeNotMobile && 
            <VisDiv>
              <AuthNav AuthContext={AuthContext} resetContextFn={resetContextFn}/>
              {/*  <ProfileMenu customer={sUser}/> */}
            </VisDiv>
          }
          {user && <ProfileMenu resetContextFn={resetContextFn}/>}
        </div>
      </div>
    </header>
  )
}

export default Navbar
